import type { DrawerProps as MantineDrawerProps } from '@mantine/core';
import { Drawer as MantineDrawer } from '@mantine/core';

import type { LockedProps } from '../types';

/** Mantine's DrawerProps minus the {@link LockedProps} style overrides. */
export type DrawerProps = Omit<MantineDrawerProps, LockedProps>;

/**
 * ### Drawer
 *
 * @description
 * Mantine's Drawer minus per-call-site style overrides (see {@link LockedProps}). Opens from the
 * right and unmounts its children on close by default; both are plain defaults, so a caller can
 * pass `position` or `keepMounted` to override them.
 *
 * @param props - {@link DrawerProps}
 * @returns React component
 */
export const Drawer = (props: DrawerProps) => (
  <MantineDrawer position="right" keepMounted={false} {...props} />
);
